export type ReportsViews = 'grid' | 'list';

export enum AnalysisReportStatusEnum {
  Unspecified = 0,
  Scheduled = 1,
  Available = 2,
  Unavailable = 3,
  Expired = 4,
}

export enum AnalysisReportOrderTypeEnum {
  Unspecified = 0,
  WrittenAtAscending = 1,
  WrittenAtDescending = 2,
  TypeAscending = 3,
  TypeDescending = 4,
  ProviderAscending = 5,
  ProviderDescending = 6,
  NameAscending = 7,
  NameDesscending = 8,
}

/* Analysis Reports - TYPES */

export interface AnalysisReportsTypesItem {
  uuid?: string;
  name: string;
}

export interface AnalysisReportsTypesApiResponse {
  types: AnalysisReportsTypesItem[];
}

/* /Analysis Reports - TYPES */

/* Analysis Reports - PROVIDERS */

export interface AnalysisReportsProvidersItem {
  uuid?: string;
  name: string;
}

export interface AnalysisReportsProvidersApiResponse {
  providers: AnalysisReportsProvidersItem[];
}

/* /Analysis Reports - PROVIDERS */

/* Analysis Reports - ANALYSTS */

export interface AnalysisReportsAnalystsItem {
  uuid?: string;
  name: string;
}

export interface AnalysisReportsAnalystsApiResponse {
  analysts: AnalysisReportsAnalystsItem[];
}

/* /Analysis Reports - ANALYSTS */

/* Analysis Reports - CATEGORIES */

export interface AnalysisReportsCategoriesItem {
  uuid?: string;
  name: string;
}

export interface AnalysisReportsCategoriesApiResponse {
  categories: AnalysisReportsCategoriesItem[];
}

/* /Analysis Reports - CATEGORIES */

export interface AnalysisReportItem {
  uuid: string;
  name: string;
  writtenAt: string;
  analysisReportTypeUuid: string;
  analysisReportTypeName: string;
  analysisReportProviderUuid: string;
  analysisReportProviderName: string;
  analysisReportAnalysts: [
    {
      analysisReportAnalystUuid: string;
      analysisReportAnalystName: string;
    }
  ];
  analysisReportCategories: [
    {
      analysisReportAnalystUuid: string;
      analysisReportAnalystName: string;
    }
  ];
  analysisReportStatus: AnalysisReportStatusEnum;
  allowedCourses: string[];
  downloadedAt: string;
  availableAt: string;
  downloadFilename: string;
}

export interface AnalysisReportState {
  reports: AnalysisReportItem[];
  currentPage: number;
  totalPages: number;
  itensPerPage: number;
}

export type AnalysisReportApiResponse = AnalysisReportState;

export interface UseReportsState {
  reports: AnalysisReportItem[];
  currentPage: number;
  totalPages: number;
  itensPerPage: number;
  setReports: (reports: AnalysisReportApiResponse) => void;
  clearReports: () => void;
  downloadReport: (downloadUrl: string, downloadFilename: string) => void;
  downloadLoading: boolean;
  downloadPercentage: number;
}
